import { ClockPuzzleResponse } from "@shared/types";
import { PlayerService } from "./PlayerService";

export class InputFieldService {
    private _playerService: PlayerService = new PlayerService();
    public async getClockCode(code: string): Promise<boolean> {
        const response: Response = await fetch(`${VITE_API_URL}clockpuzzle/get-clockcode/${code}`, {
            method: "GET",
            headers: {
                "X-PlayerSessionId": this._playerService.getPlayerSessionId(),
            },
        }
        );
        const data: ClockPuzzleResponse = await response.json() as ClockPuzzleResponse;
        return data.response;
    }

    public async exitPuzzle(check: boolean): Promise<boolean> {
        const response: Response = await fetch(`${VITE_API_URL}clockpuzzle/exit-puzzle/${check}`, {
            method: "GET",
            headers: {
                "X-PlayerSessionId": this._playerService.getPlayerSessionId(),
            },
        }
        );
        const data: ClockPuzzleResponse = await response.json() as ClockPuzzleResponse;
        return data.check;
    }
}
